import Axios, * as others from 'axios';
import URL from '../../Environment';
import React, { Component,useEffect, useState } from "react";
import { format } from "date-fns";
import { Link } from 'react-router-dom';
import IMGPATHS from '../../ImgPaths';

    const encodeFileName = (fileName) => {
      return `${encodeURIComponent(fileName)}`;
    };

const Anoucement = () => {

    const [ANCData, setANCData] = useState([]);
    const [loadingANC, setANCLoading] = useState(true);
    const [errorANC, setANCError] = useState(null);

    useEffect(() => {

      const fetchANCData = async () => {

            Axios.get(URL + `api/Annoucement/GetAnnouncement`).then((response) => {
              const res = response.data;
              //console.log(res);
      
              setANCData(response.data);
              setANCLoading(false);   
      
            }).catch((error) => {
              setANCError(error);
              setANCLoading(false); 
      
            });
        };
      
        // เรียกใช้งาน fetchData เมื่อค่าตัวแปร count มีการเปลี่ยนแปลง
        fetchANCData();
      
        // Cleanup function ที่จะถูกเรียกเมื่อ component ถูก unmount
        return () => {
          // ทำการคืนการทำงานที่ต้องการ (cleanup)
          //console.log('Component unmounted');
        };

  }, []);

  if (loadingANC) {
      return <div>Loading...</div>;
  }
  
  if (errorANC) {
      return <div>Error: {errorANC.message}</div>;
  }

    return (
    <div>
      <section className="breadcrumbs">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
              <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
              <i className="fa fa-angle-right" />&nbsp;<a href="anoucement" className="a-breadcrumbs">ประกาศ</a>
            </div>
          </div>
        </div>
      </section>
      <section className="page-section">
        <div className="container">
          <div className="row">
            <div className="col-md-10 col-sm-9 mb-sm-50" style={{ fontFamily: "Cordia New" }}>
              {/* Section Title */}
              <h2 className="title-section mt-0 mb-0">
                <span>ประกาศ</span>
              </h2><br/>
              <div className="divider gray left mt-20 mb-25"></div>

              <table className="table table-model-2 table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>หัวข้อประกาศ</th>
                    <th style={{ textAlign: "right" }}>วันที่ประกาศ</th>
                    <th style={{ textAlign: "center" }}>ประกาศโดย</th>
                  </tr>
                </thead>
                <tbody>
                  {ANCData.map((announcement, index) => (
                    <tr key={index}>
                      <td>
                        {/* {index === 0 && (
                          <span
                            style={{
                              backgroundColor: "red",
                              color: "white",
                              borderRadius: ".25rem",
                              padding: "2px 6px",
                            }}
                          >
                            New
                          </span>
                        )} */}
                      </td>
                      <td>
                      {/* announcement.link ||  */}
                        <a
                          href={`${IMGPATHS}Form/Annoucement/${encodeFileName(announcement.attachfile)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#0094ff" }}
                        >
                          {announcement.topic}
                        </a>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {/* {announcement.dateannounce } */}
                        {format(new Date(announcement.dateannounce), "d MMMM, yyyy")}
                        </td>
                      <td style={{ textAlign: "center" }}>{announcement.announceby}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </section>
    </div>
    );
}

export default Anoucement;
